import { render, staticRenderFns } from "./SmsContactList.vue?vue&type=template&id=1f70ae58&scoped=true&"
import script from "./SmsContactList.vue?vue&type=script&lang=js&"
export * from "./SmsContactList.vue?vue&type=script&lang=js&"
import style0 from "./scoped.scss?vue&type=style&index=0&id=1f70ae58&prod&lang=scss&scoped=true&"
import style1 from "./global.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f70ae58",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Flocal%2Fbamboo-home%2Flocal-working-dir%2F56885249%2FEIPSMS-UB-DB%2Fsrc%2Fcomponents%2FSmsContactList%2FSmsContactList.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports